import { call, put } from 'redux-saga/effects';

import api from 'api';

import { notifyError } from 'store/notifications/actions';

import { IChannelDeeplinkResponse } from 'types/bigScreen';

import { getBigScreenDeepLinkSuccess } from '../actions';

export function* getBigScreenSaga() {
    try {
        const deepLink: IChannelDeeplinkResponse = yield call(api.user.getChannelDeepLink);

        yield put(getBigScreenDeepLinkSuccess({ ...deepLink, bigScreenTokenTTL: Date.now() }));
    } catch (error: any) {
        yield put(notifyError({ message: 'message.error.somethingWentWrong' }));
    }
}
